import React from "react";

const ToastMessage = ({ toastMessage }) => {
 
  const getToastColor = () => {
    const lowerMessage = toastMessage.toLowerCase();
    
    if (lowerMessage.includes("success") || lowerMessage.includes("status changed")) {
      return { bg: "bg-green-400", border: "border-green-700" };
    }
    if (lowerMessage.includes("fail") || lowerMessage.includes("error")) {
      return { bg: "bg-red-400", border: "border-red-700" };
    }
    if (lowerMessage.includes("pending") || lowerMessage.includes("not completed")) {
      return { bg: "bg-yellow-400", border: "border-yellow-700" };
    }
   
    return { bg: "bg-blue-400", border: "border-blue-700" };
  };

  const colors = getToastColor();

  return (
    <div className={`absolute bottom-10 z-50 left-1/2 transform -translate-x-1/2 rounded-full py-2 px-12 text-center w-fit ${colors.bg} ${colors.border} border-[1px] text-black shadow-md font-semibold`}>
      {toastMessage}
    </div>
  );
};

export default ToastMessage;
